import './team-history.styles.scss';
import { Link } from 'react-router-dom';

// A team's past seasons, newest first (team.history, one line a year,
// written when each season is archived). seasonLink(year) -> path.
const TeamHistory = ({ team, league, seasonLink }) => {

    const lines = [...(team.history ?? [])].sort((a, b) => b.year - a.year);
    if (lines.length === 0) return null;
    const pro = league.type === 'pro';

    return (
        <div className='g-card team-history'>
            <h3>History</h3>
            <div className='table-scroll'>
                <table className='g-table'>
                    <thead>
                        <tr>
                            <th>Season</th>
                            <th className='num'>W-L</th>
                            <th className='num'>Conf</th>
                            <th className='num' title={pro ? 'Final power ranking' : 'Final ranking'}>Rank</th>
                            <th>{pro ? 'Playoffs' : 'Postseason'}</th>
                            <th>Manager</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lines.map(h => (
                            <tr key={h.year} className={h.finish === 'Champion' ? 'champ' : ''}>
                                <td>{seasonLink ? <Link to={seasonLink(h.year)}>{h.year}</Link> : h.year}</td>
                                <td className='num'>{h.w}-{h.l}{pro && (h.postW || h.postL) ? <span className='meta'> ({h.postW}-{h.postL})</span> : null}</td>
                                <td className='num'>{h.confW}-{h.confL}</td>
                                <td className='num'>{h.poll && (pro || h.poll <= 25) ? `#${h.poll}` : '-'}</td>
                                <td>{h.finish}{titles(h)}</td>
                                <td className='meta'>{h.managerName ?? 'Computer'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

// Conference titles after the postseason result. Seasons archived before
// regular-season champions were recorded only know the tournament winner.
function titles(h) {
    const list = [];
    if (h.confRegular) list.push('Conf. champ');
    if (h.confTournament || (h.confRegular === undefined && h.confChampion)) list.push('Conf. tourney champ');
    return list.length ? ` · ${list.join(' · ')}` : '';
}

export default TeamHistory
